import script from "./CoreUiChatHistoryMessageButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatHistoryMessageButton.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatHistoryMessageButton.vue?vue&type=style&index=0&id=770ca60d&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770ca60d"]])

export default __exports__